import BalanceDebit from './BalanceDebit';

export default BalanceDebit;
